import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import request from "request";
import TagSearch from "../components/TagSearch";
import * as qs from "query-string";
import StarIcon from "../icons/star_solo.svg";
import BlueStarIcon from "../icons/blue_star.svg";
import GoldStarIcon from "../icons/star_gold.svg";
import { apiUrl, formatReportDate, getDurationToGivenDate } from "../util";

const USER_COMPANY_REFRESH_INTERVAL = 1 * 60 * 1000;
class AutoAssignedQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      loading: true,
      tlds: this.getCompanies(),
      today: this.getToday(),
      priorityCompany: "all",
      isUserCheckedIn: false,
      checkinTime: null,
    };
  }
  refreshData = null;
  time = new Date().getTime();
  visibleEvent = () => {
    if (!document.hidden) {
      clearInterval(this.refreshData);

      const newTime = new Date().getTime();
      if (newTime - this.time >= USER_COMPANY_REFRESH_INTERVAL) {
        this.getData();
        this.time = newTime;
      }
      this.refreshData = setInterval(() => {
        this.getData();
      }, USER_COMPANY_REFRESH_INTERVAL);
    } else {
      clearInterval(this.refreshData);
    }
  };
  componentDidMount() {
    this.getUserCheckinStatus();
    document.addEventListener("visibilitychange", this.visibleEvent);
  }
  getCompanies = () => {
    const { companies } = qs.parse(window.location.search);

    if (companies) {
      return companies.split("|");
    }
    return null;
  };
  getToday = () => {
    const { today } = qs.parse(window.location.search);

    return today ? true : false;
  };
  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this.visibleEvent);
    clearInterval(this.refreshData);
  }
  getData = () => {
    let url = `${apiUrl}/v1/admin/v2/getAutoQueueItemsByCompany`;

    if (this.state.today) {
      url = `${url}?today=true`;
    }
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        json.companies.sort((a, b) => {
          if (a.name && b.name) {
            return a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1;
          }
        });
        let initialCompanies;
        const tlds = this.getCompanies();
        if (tlds) {
          initialCompanies = json.companies
            .filter(c => tlds.includes(c.tld))
            .map(c => ({ label: `${c.name} (${c.tld})`, value: c.tld }));
        }
        this.setState({
          companies: json.companies.filter(c => c.queue_count > 0),
          loading: false,
          initialCompanies,
        });
      }
    );
  };
  getUserCheckinStatus = () => {
    let url = `${apiUrl}/v1/admin/v2/getUserCheckinStatus`;

    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        if (json.checkin) {
          this.setState({
            isUserCheckedIn: true,
            checkinTime: json.time,
            loading: false,
          });
          this.getData();
        } else {
          this.setState({
            isUserCheckedIn: false,
            checkinTime: null,
            loading: false,
          });
        }
      }
    );
  };
  checkInUser = e => {
    this.setState({
      loading: true,
    });
    let url = `${apiUrl}/v1/admin/v2/checkin`;
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          this.setState({
            loading: false,
          });
          return;
        } else {
          this.setState({
            isUserCheckedIn: true,
          });
        }
        console.log({ err, res, data });
        this.getData();
        if (!this.refreshData) {
          //this.getUserData(this.state.user, true);
          this.refreshData = setInterval(() => {
            this.getData();
          }, USER_COMPANY_REFRESH_INTERVAL);
        }
      }
    );
  };
  checkOutUser = e => {
    this.setState({
      loading: true,
    });
    let url = `${apiUrl}/v1/admin/v2/checkout`;
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          this.setState({
            loading: false,
          });
          return;
        } else {
          this.setState({
            isUserCheckedIn: false,
            checkinTime: null,
          });
        }
        console.log({ err, res, data });
        this.getData();
        if (this.refreshData) {
          clearInterval(this.refreshData);
        }
      }
    );
  };
  getMoreCompanies = e => {
    this.setState({
      loading: true,
    });
    let url = `${apiUrl}/v1/admin/v2/checkin?more=true`;
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          this.setState({
            loading: false,
          });
          return;
        }
        this.getData();
      }
    );
  };
  doTldFilter = vals => {
    if (vals && vals.length > 0) {
      this.props.history.push(`/queue/company?companies=${vals.join("|")}`);
    } else {
      this.props.history.push(`/queue/company`);
    }
    this.setState({ tlds: vals });
  };
  doFilter = () => {
    const { tlds, companies } = this.state;
    if (tlds && tlds.length > 0) {
      return companies.filter(c => tlds.includes(c.tld));
    }
    return companies;
  };
  doSortByPriority = companies => {
    companies.sort((a, b) => {
      if (a.priorityCompany && b.priorityCompany) {
        return b.queue_count - a.queue_count;
      }
      if (a.priorityCompany && !b.priorityCompany) {
        return -1;
      } else if (!a.priorityCompany && b.priorityCompany) {
        return 1;
      } else {
        return 0;
      }
    });
    return companies;
  };
  onChangePriorityCompanyFilter = e => {
    const priorityCompany = e.target.checked;
    this.setState({
      priorityCompany: priorityCompany ? "only" : "all",
    });
  };
  render() {
    const { user } = this.props;
    const data = this.doSortByPriority(this.doFilter());
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (this.state.loading) {
      return <h1>Loading&hellip;</h1>;
    }

    return (
      <div>
        <h1>Queues by Company</h1>
        <div className="w-100 flex  items-center">
          {/* <div className="ph2 pt1">
            <img
              src={StarIcon}
              alt="show only prioriry company"
              // className="share-icon"
              // style={{ marginTop: "-4px" }}
              className="ph1"
            />
            <span className="ph1">Priority</span>
            <input
              type="checkbox"
              color="primary"
              name="priorityCompany"
              checked={this.state.priorityCompany === "only"}
              onChange={this.onChangePriorityCompanyFilter}
            />
          </div> */}
          {this.state.isUserCheckedIn ? (
            <>
              <div className="w-50">
                <TagSearch
                  options={this.state.companies.map(c => ({
                    label: `${c.name} (${c.tld})`,
                    value: c.tld,
                  }))}
                  callback={this.doTldFilter}
                  placeholder="Filter by company"
                  defaultTags={this.state.initialCompanies}
                />
              </div>
              <div className="ph2 pt1">
                <button className="ph2 pt1" onClick={this.checkOutUser}>
                  Check-Out
                </button>
              </div>
              <div className="ph2 pt1">
                <button className="ph2 pt1" onClick={this.getMoreCompanies}>
                  Get more companies
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="ph2 pt1">
                <button className="ph2 pt1" onClick={this.checkInUser}>
                  Check-In
                </button>
              </div>
            </>
          )}
        </div>

        {data.map(company => (
          <div className="mt3 f4 flex items-center" key={company.tld}>
            {company.priorityCompany && (
              <img
                src={StarIcon}
                // height="20"

                alt="Priority Company"
                className="ph1"
              />
            )}
            {company.regularPriority && (
              <img
                src={BlueStarIcon}
                // height="20"

                alt="Regular Priority Company"
                className="ph1"
              />
            )}
            {company.competitorPriority && (
              <img
                src={GoldStarIcon}
                // height="20"

                alt="Competitor Alert Priority Company"
                className="ph1"
              />
            )}
            {company.name} ({company.tld}){" "}
            <Link
              to={`/queue/auto/company/${encodeURIComponent(company.tld)}${
                company.country ? `#${company.country}` : ``
              }`}
            >
              <b>{company.queue_count}</b> items in queue
            </Link>
            {company.lock && company.lock === "retain" && (
              <p className="ph1 mb0">
                Retained until{" "}
                {formatReportDate(
                  new Date(company.retain_until).toISOString()
                )}{" "}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default AutoAssignedQueue;
